<template>
  <transition :name="`${ $device.isMobile ? 'SLIDE' : 'NONE'}`" mode="out-in">
    <div v-if="!$device.isMobile || jobId" class="CONTENT">
      <fire-toast v-if="!$device.isMobile" />
      <template v-if="job">
        <transition name="FADE" mode="out-in">
          <div :key="jobId" class="CONTENT-CONTAINER">
            <top-bar />
            <pro-notes />
            <dashboard-section
                v-if="$device.isMobile && isCompleted"
                :bordered="$device.isMobileOrTablet"
                class="d-flex jc-center c-depot">
              <vk-icon
                  name="camera"
                  class="m-r-1"
                  size="20"/>
              <span @click="gotoAddPhoto" class="text-md">
                ADD PROJECT PHOTOS TO PROFILE
              </span>
            </dashboard-section>
            <pro-roofing-details v-if="isHiredStatusAlias && isRoofer" />
            <pro-appointments v-if="!isNewStatusAlias" />
            <work-order-details />
            <pro-shopping v-if="isPotentialStatusAlias || isHiredStatusAlias" />
            <tool-rental v-if="isPotentialStatusAlias || isHiredStatusAlias" />
            <dashboard-section
                v-if="$device.isMobileOrTablet && !isFinishedMatch
                || $device.isMobileOrTablet && isClosedMatch"
                :bordered="$device.isMobileOrTablet"
                class="SECONDARY-CTA">
              <secondary-cta />
            </dashboard-section>
          </div>
        </transition>
        <pro-messages />
      </template>
    </div>
  </transition>
</template>

<script>
import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';
import DashboardSection from '@/views/Dashboard/components/DashboardSection';
import { mapActions, mapGetters } from 'vuex';

import TopBar from './components/TopBar';
import ProNotes from './components/ProNotes';
import ToolRental from './components/ToolRental/index';
import ProAppointments from './components/ProAppointments';
import ProRoofingDetails from './components/ProRoofingDetails';
import WorkOrderDetails from './components/WorkOrderDetails';
import ProMessages from './components/ProMessages';
import SecondaryCta from './components/TopBar/SecondaryCta';
import ProShopping from './components/ProShopping';

export default {
  name: 'dashboard-content',
  components: {
    TopBar,
    ProNotes,
    ProAppointments,
    ProRoofingDetails,
    WorkOrderDetails,
    ProMessages,
    DashboardSection,
    SecondaryCta,
    ToolRental,
    ProShopping,
  },
  mixins: [
    jobParams,
    job,
  ],
  computed: {
    ...mapGetters('ui', ['proShoppingIds']),
    ...mapGetters('account/pro', { occupations: 'serviceProviderCatalogOccupations' }),
    isCompleted () {
      return this.match.status === jobParams.MATCH_STATUSES.COMPLETED;
    },
    occupationId () {
      const matchingOccupation = Object.keys(this.occupations)
        .find(
          key => this.occupations[key].occupation_id === this.match.occupation_id
        );
      return matchingOccupation;
    },
    isRoofer () {
      const occupation = this.occupations[this.occupationId];
      if (!occupation || !occupation.occupation) {
        return false;
      }
      const occupationName = occupation.occupation.display_name || occupation.occupation.name || '';
      return occupationName.toLowerCase().includes('roof');
    },
  },
  watch: {
    jobId (prev, cur) {
      if (prev !== cur) {
        this.fetch();
      }
    },
  },
  mounted () {
    this.fetch();
  },
  methods: {
    ...mapActions('ui', ['fetchProShoppingIds']),
    async fetch () {
      if (Object.keys(this.proShoppingIds).length === 0) {
        this.fetchProShoppingIds();
      }

      if (this.job && this.job.order_hash) {
        const jobId = this.job.order_hash;

        await this.transitionJob({
          action: this.$options.MATCH_STATUS_ACTIONS.SEE,
          order_hash: jobId,
        });

        await this.fetchWorkOrderMatches({
          params: {
            order_hash: jobId,
            size: 1,
          },
        });
      }
    },
    gotoAddPhoto () {
      this.$router.replace({
        name: 'account::pro::occupation',
        params: {
          serviceProviderOccupationId: this.occupationId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .CONTENT {
    @include absolute(0, 0, 0, 0);
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    background-color: white;
    box-shadow: 0 0 10px rgba(black, 0.2);
    overflow: hidden;

    @include tablet {
      position: relative;
      border-right: 1px solid $color-gray30;
      box-shadow: none;
    }

    @include desktop {
      overflow-x: auto;
      overflow-y: hidden;
    }
  }

  .CONTENT-CONTAINER {
    @include padding-bottom(0, 0, 9);
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    overflow-y: scroll;
  }

  .SECONDARY-CTA {
    position: sticky;
    bottom: 0;
    padding: 0;
  }

  .SLIDE-enter-active,
  .SLIDE-leave-active {
    transform: none;
    will-change: transform;
    transition: transform $transition-duration;

    &.SLIDE-enter,
    &.SLIDE-leave-to {
      transform: translateX(103%);
    }
  }
</style>
